var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.cellData.SurveyWave && _vm.getInfo())?_c('div',_vm._l((_vm.cellData.entries),function(entry){return _c('div',{key:entry,staticClass:"truncate"},[_vm._v("\n      "+_vm._s(entry.Name)+"\n    ")])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }